import { render, staticRenderFns } from "./PWR02G05.vue?vue&type=template&id=281b44dd&scoped=true"
import script from "./PWR02G05.vue?vue&type=script&lang=jsx"
export * from "./PWR02G05.vue?vue&type=script&lang=jsx"
import style0 from "./PWR02G05.vue?vue&type=style&index=0&id=281b44dd&lang=scss&scoped=true"
import style1 from "./PWR02G05.vue?vue&type=style&index=1&id=281b44dd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b44dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281b44dd')) {
      api.createRecord('281b44dd', component.options)
    } else {
      api.reload('281b44dd', component.options)
    }
    module.hot.accept("./PWR02G05.vue?vue&type=template&id=281b44dd&scoped=true", function () {
      api.rerender('281b44dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pwr/PWR02G05.vue"
export default component.exports